import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { useState } from "react";
import BossDialog from "../../components/BossDialog";
import { ImageBrowser } from "../../framework/forms/helpercomponents/selectFile/ImageBrowser";
import * as API from "../../framework/API/api";
import ToastNotification from "../../components/ToastNotification";
import { TOAST_TYPES } from "../../framework/constant/constant";

const MMImageEditForm = (props) => {

  let isBrowse = props?.isBrowse ?? false;

  const [image, setImage] = useState(props?.selectedImageUrl);

  const lang = useTranslation();

  const onChange = async (e) => {

    let value = "";

    if (isBrowse) {
      let imageRes = await API.uploadImage(e.target.files[0]);

      if (!imageRes?.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: imageRes.message });
        return;
      }
      value = imageRes.data;
    } else {
      value = e.target.value;
    }
    setImage(value);
  }

  const onClose = () => {
    props.onClose();
  }

  const handleSubmit = () => {
    props.setDataList(image);
    onClose();
  }

  return (
    <BossDialog
      title={lang.edit_image_url_dialog_header}
      onClose={onClose}
      width={"500px"}
    >
      <EditPageHeader onSubmit={handleSubmit} saveButtonTitle={lang.confirm_button_text} onCancel={onClose} showTitle={false} />

      {!props.isBrowse && <div className="form-group mt-2">
        <label htmlFor="">{lang.image_url_label}</label>
        <input type="text" name="ImageUrl" className="form-control" placeholder="Url" value={image} onChange={onChange} />

      </div>}

      {props.isBrowse && <ImageBrowser
        id={"ImageUrl"}
        name={"ImageUrl"}
        value={image}
        onChange={onChange}
        setSelectedImage={props.setSelectedImage}
        hidePosterLibrary={true}
      />}
    </BossDialog>
  )
}

export default MMImageEditForm;